import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=4bc81137&"
import script from "./Checkout.vue?vue&type=script&lang=ts&"
export * from "./Checkout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports